import React, { useEffect, useState } from "react";
import { SearchIcon } from "@heroicons/react/solid";
import { confirmDeleteInvitedUser, getInvitedUsers } from '../../services/authService';
import { getCookie } from "../../utils/cookieUtil";

function InvitedUsers({ counter }) {
  const [invitedUsers, setInvitedUsers] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [permission, setPermission] = useState('');
  const [currentInvitationUsersPage, setCurrentInvitationUsersPage] = useState(1);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);



  const itemsPerPage = 10;

  useEffect(() => {
    fetchInvitedUsers()
  }, [counter]);

  useEffect(() => {
    const roles = getCookie('roleId');
    if (roles) {
      setPermission(`${roles} `);
    }
  }, []);

  const fetchInvitedUsers = async () => {
    setDataLoading(true);
    try {
      const res = await getInvitedUsers();
      const data = await res.json();
      setInvitedUsers(data.users);

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setDataLoading(false);
    }
  };


  const handleDeleteClick = (email) => {
    setUserToDelete(email);
    setShowConfirmationModal(true);
  };



  const confirmDelete = async () => {
    try {
      setDataLoading(true);
      await confirmDeleteInvitedUser(userToDelete);
      setShowConfirmationModal(false);
      setUserToDelete(null);
      setDataLoading(false);
      fetchInvitedUsers()
    } catch (error) {
      console.error('[ERROR] Failed to complete deletion process:', error);
    }
  };

  const cancelDelete = () => {
    setShowConfirmationModal(false);
    setUserToDelete(null);
  };

  const handleSearchInvitationUsersChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentInvitationUsersPage(1);
  };

  const filteredInvitationUsers = Array.isArray(invitedUsers) ? invitedUsers.filter(user =>
    user?.email?.toLowerCase().includes(searchQuery.toLowerCase())
  ) : [];


  const InvitationUsersstartIndex = (currentInvitationUsersPage - 1) * itemsPerPage;
  const currentInvitationUsers = filteredInvitationUsers.slice(InvitationUsersstartIndex, InvitationUsersstartIndex + itemsPerPage);
  const InvitationUserstotalPages = Math.ceil(filteredInvitationUsers.length / itemsPerPage);

  const goToPreviousInvitationUsersPage = () => {
    setCurrentInvitationUsersPage((prev) => Math.max(prev - 1, 1));
  };

  const goToNextInvitationUsersPage = () => {
    setCurrentInvitationUsersPage((prev) => Math.min(prev + 1, InvitationUserstotalPages));
  };

  if (dataLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="w-16 h-16 border-t-4 border-[#900028] border-solid rounded-full animate-spin"></div>
      </div>
    );
  }


  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        {permission.includes("adduser") && (
          <div className="ml-auto w-full max-w-md">
            <div className="flex items-center bg-white shadow-sm border border-gray-200 rounded-xl overflow-hidden focus-within:ring-2 focus-within:ring-[#900028] transition-all duration-200">
              <input
                type="text"
                placeholder="Search by email..."
                value={searchQuery}
                onChange={handleSearchInvitationUsersChange}
                className="flex-1 px-5 py-2.5 text-sm text-gray-800 placeholder-gray-400 bg-transparent focus:outline-none"
              />
              <button
                className="p-3 bg-[#900028] hover:bg-[#a1243b] transition-all duration-200 text-white flex items-center justify-center"
              >
                <SearchIcon className="w-5 h-5" />
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="flex-1 overflow-x-auto">
        {/* <table className="w-full text-sm text-left border-collapse">
          <thead className="bg-[#FF96B3]">
            <tr>
              {permission.includes("adduser") && (
                <>
                  <th className="py-2 px-4 border-b border-gray-300 text-black-500">Email</th>
                  <th className="py-2 px-4 border-b border-gray-300">First Name</th>
                  <th className="py-2 px-4 border-b border-gray-300">Second Name</th>
                </>
              )}
              <th className="py-2 px-4 border-b border-gray-300">Group</th>
              <th className="py-2 px-4 border-b border-gray-300">Action</th>
            </tr>
          </thead>
          <tbody>
            {currentInvitationUsers.map(user => (
              <tr key={user.uid} className="bg-[#F3E2E7] hover:bg-[#F1C4D8] text-gray transition duration-200">
                {permission.includes("adduser") && (
                  <>
                    <td className="py-2 px-4 border-b border-gray-300">{user.email}</td>
                    <td className="py-2 px-4 border-b border-gray-300">{user.firstName}</td>
                    <td className="py-2 px-4 border-b border-gray-300">{user.secondName}</td>
                  </>
                )}
                <td className="py-2 px-4 border-b border-gray-300">{user.group}</td>
                <td className="py-2 px-4 border-b border-gray-300">
                  <div className="flex space-x-2">
                    {permission.includes("adduser") && (
                      <button
                      onClick={() => handleDeleteClick(user.email)}
                      className="bg-red-700 text-white font-semibold py-1 px-3 rounded-md shadow transition duration-200 w-16"
                  >
                      Delete
                  </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table> */}

        <div className="overflow-x-auto bg-white shadow-lg rounded-2xl border border-gray-200">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="bg-[#900028] text-gray-100 text-xs uppercase tracking-wider">
              <tr>
                {permission.includes("adduser") && (
                  <>
                    <th className="px-6 py-4">Email</th>
                    <th className="px-6 py-4">First Name</th>
                    <th className="px-6 py-4">Second Name</th>
                  </>
                )}
                <th className="px-6 py-4">Group</th>
                <th className="px-6 py-4 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {currentInvitationUsers.map((user) => (
                <tr
                  key={user.uid}
                  className="hover:bg-[#FFF3F7] transition-colors duration-200"
                >
                  {permission.includes("adduser") && (
                    <>
                      <td className="px-6 py-4 whitespace-nowrap font-medium flex items-center space-x-2">
                        <div className="bg-[#FFD1E1] text-[#900028] font-bold w-8 h-8 rounded-full flex items-center justify-center text-xs">
                          {user.email.charAt(0).toUpperCase()}
                        </div>
                        <span>{user.email}</span>
                      </td>
                      <td className="px-6 py-4">{user.firstName}</td>
                      <td className="px-6 py-4">{user.secondName}</td>
                    </>
                  )}
                  <td className="px-6 py-4">
                    <span className="inline-block bg-[#FFE1ED] text-[#900028] px-2 py-1 text-xs font-semibold rounded-full">
                      {user.group}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <div className="flex justify-center space-x-2">
                      {permission.includes("adduser") && (
                        <button
                          onClick={() => handleDeleteClick(user.email)}
                          className="text-red-600 border border-red-600 hover:bg-red-600 hover:text-white transition-all duration-200 text-xs font-semibold py-1 px-4 rounded-md"
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-end items-center mt-4 mb-2 space-x-2">
          <button
            onClick={goToPreviousInvitationUsersPage}
            disabled={currentInvitationUsersPage === 1}
            className="px-3 py-2 bg-gray-300 rounded disabled:opacity-50"
          >
            &larr;
          </button>
          <span className="px-2">
            {`1-${Math.min(itemsPerPage, filteredInvitationUsers.length - InvitationUsersstartIndex)} of ${currentInvitationUsersPage}`}
          </span>
          <button
            onClick={goToNextInvitationUsersPage}
            disabled={currentInvitationUsersPage === InvitationUserstotalPages}
            className="px-3 py-2 bg-gray-300 rounded disabled:opacity-50"
          >
            &rarr;
          </button>
        </div>
      </div>
      {showConfirmationModal && (
  <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-4">
    <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-6 transition-all duration-300 ease-in-out animate-fade-in">
      <h3 className="text-xl font-semibold text-gray-900 mb-3">Confirm Deletion</h3>
      <p className="text-gray-600 mb-6">
        Are you sure you want to permanently delete this user?
      </p>
      <div className="flex justify-end gap-3">
        <button
          onClick={cancelDelete}
          className="px-5 py-2 text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition duration-200"
        >
          Cancel
        </button>
        <button
          onClick={() => confirmDelete(userToDelete)}
          className="px-5 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm transition duration-200"
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  )
}

export default InvitedUsers
